import { forwardRef, useMemo, createElement as h } from 'react'
import { getIconHref } from './SvgIcon'

const Icon = forwardRef(({
  rotate = 0,
  href,
  size = 150,
  width,
  height,
  fill = '',
  ...args
}, ref) => {

  if (!width || !height) width = height = size

  return (
    h(
      'div',
      {
        ref,
        style: { width, height, transition: '.3s all ease', transform: `rotate(${rotate}deg)` },
        ...args
      },
      h(
        'svg',
        {
          style: { width, height, fill }
        },
        h(
          'use',
          {
            xlinkHref: useMemo(() => getIconHref(href), [ href ])
          }
        )
      )
    )
  )

})

export {
  Icon
}